import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useEffect, useState } from "react";

interface IndexChartInterface {
  label?: string;
  cor?: string[];
  value: number;
}

const IndexChart: React.FC<IndexChartInterface> = (props) => {
  const { label = "", cor = ["#7fa2fc"], value = 0 } = props;
  const [hack, setHack] = useState<string>("");

  useEffect(() => {
    setTimeout(() => {
      //small screen o gráfico fica perdido, assim forçamos ele a recalcular os tamanhos
      setHack("hack");
    }, 1000);
  }, []);

  const options: ApexOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "70%",
          margin: 0,
        },
        dataLabels: {
          value: {
            formatter: (val) => `${val}`,
            fontSize: "20px",
            color: [...cor].pop(),
          },
          name: {
            fontSize: "20px",
            offsetY: 0,
          },
        },
      },
    },
    colors: cor,
    stroke: {
      lineCap: "round",
    },
    labels: [label],
    legend: {
      fontSize: "16px",
      labels: {
        colors: "white",
      },
    },
  };
  const series = [value];

  return (
    <div className={hack}>
      <Chart options={options} series={series} type="radialBar" />
    </div>
  );
};

export default IndexChart;
